export default class MenuMobile {
	constructor() {
		this.hamburger = document.querySelector(".hamburger");
		this.header = document.querySelector(".header");
		this.openSubmenuBtn = document.querySelectorAll(".open-submenu");
		this.hamburgerLockFlag = true;
		this.mobileMenuOpen = false;
		this.mobileMenuContainer = document.querySelector(".nav-mobile__container");
		this.events();
	}

	events() {
		if (this.hamburger) {
			this.hamburger.addEventListener("click", this.hamburgerMenuClick.bind(this));
		}

		for (let i = 0; i < this.openSubmenuBtn.length; i++) {
			this.openSubmenuBtn[i].addEventListener(
				"click",
				function () {
					this.submenu(this.openSubmenuBtn[i]);
				}.bind(this)
			);
		}

		if (this.mobileMenuContainer) {
			this.mobileMenuContainer.setAttribute("aria-expanded", "false");
			this.mobileMenuContainer.setAttribute("aria-hidden", "true");
		}

		window.addEventListener("resize", this.handleResize.bind(this));
	}

	submenu(element) {
		element.classList.toggle("arrow-rotate");
		element = element.parentElement;
		let submenu = element.querySelector(".nav-mobile .submenu");
		if (submenu) {
			submenu.classList.toggle("active-submenu");
			let expanded = submenu.getAttribute("aria-expanded") === "true";
			let hidden = submenu.getAttribute("aria-hidden") === "true";
			submenu.setAttribute("aria-expanded", !expanded);
			submenu.setAttribute("aria-hidden", !hidden);
		}
	}

	hamburger_lock() {
		setTimeout(
			function () {
				this.hamburgerLockFlag = true;
			}.bind(this),
			500
		);
	}

	hamburgerMenuClick() {
		if (this.hamburgerLockFlag === false) return;

		this.hamburgerLockFlag = false;
		this.hamburger_lock();
		this.hamburger.classList.toggle("open");

		if (this.mobileMenuOpen === false) {
			this.mobileMenuOpen = true;
			this.open_mobile_menu();
		} else {
			this.mobileMenuOpen = false;
			this.close_mobile_menu();
		}
	}

	open_mobile_menu() {
		this.mobileMenuContainer.style.display = "flex";
		setTimeout(
			function () {
				this.mobileMenuContainer.style.transform = "translate3d(0,0,0)";
				this.mobileMenuContainer.style.opacity = "1";
				this.mobileMenuContainer.setAttribute("aria-expanded", "true");
				this.mobileMenuContainer.setAttribute("aria-hidden", "false");
				this.header.classList.add("mobile-opened");
			}.bind(this),
			25
		);
	}

	close_mobile_menu() {
		this.mobileMenuContainer.style.transform = "translate3d(100%,0,0)";
		this.mobileMenuContainer.style.opacity = "0";
		setTimeout(
			function () {
				this.mobileMenuContainer.style.display = "none";
				this.mobileMenuContainer.setAttribute("aria-expanded", "false");
				this.mobileMenuContainer.setAttribute("aria-hidden", "true");
				this.header.classList.remove("mobile-opened");
			}.bind(this),
			250
		);
	}

	handleResize() {
		if (this.mobileMenuOpen === true) {
			this.hamburger.classList.remove("open");
			this.mobileMenuOpen = false;
			this.close_mobile_menu();
		}
	}
}
